import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { AccountService } from "../account.service";
import { UserRoleType } from '../models/survey';

/**
 * Checks if current role is of type 'Navigator'. Used to restrict specific routes to users with role of 'Navigator'. 
 */
@Injectable({
    providedIn: 'root'
})
export class NavRoleGuard implements CanActivate {

    constructor(
        private _accountService: AccountService,
        private _router: Router
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): MaybeAsync<GuardResult> {

        if (this._accountService.session?.role == UserRoleType.Navigator) {
            return true;
        }
        else {
            this._router.navigate(['/landing']);
            return false;
        }
    }
}